import { useState } from 'react';
import { makeApiRequest, RequestStatus } from '../../api_request/api_request';
import { useAppDispatch } from '../../store/hooks';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { email_pattern } from './UserRegistrationForm';
import { GetPageTitle } from '../../ErnotsConfig';

export function ResendActivationEmail()
{
    const appDispatch = useAppDispatch();

    const [email, setEmail] = useState<string>('');
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>)
    {
        e.preventDefault();
        if (!email_pattern.test(email))
        {
            return;
        }
        
        const userData = {email};
        makeApiRequest({
            endpoint: 'users/resend_activation/',
            method: 'POST',
            postData: userData,
            dispatch: appDispatch,
            lifeCycleCallback: setRequest,
            useAuthPrefix: true
        });
    }

    const ret = (
        <div>
            <h2>Resend Activation Email</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="email">Email address associated with your account</label>
                    <Input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <Valid bValid={email.trim()} children='An email address is required.'/>
                </div>
                <Button type='submit'>Resend Activation Email</Button>
            </form>
            <RequestStatusDisplay request={request}/>
        </div>
    );

    return (
        <div className='ernots_User ernots_ResendActivationEmail'>
            <title>{GetPageTitle('Resend Activation Email')}</title>
            {ret}
        </div>);
};